import React, { useContext, useEffect, useState } from 'react'
import style from './AboutChimp.module.css'
import AlternatingOne from './Alternating'
import AlternatingTwo from './Alternating2'
import { useNavigate } from 'react-router-dom'
import GuestContext from './../../../contexts/GuestContext'

const AboutChimp = () => {
  const [openFirst, setOpenFirst] = useState(false)
  const [openSecond, setOpenSecond] = useState(false)
  const [openThird, setOpenThird] = useState(false)
  const { setOpenGuestInfo} = useContext(GuestContext)

  const navigate = useNavigate()
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY

      if (scrollY > 650 && scrollY < 950) {
        setOpenFirst(true)
      }

      if (scrollY > 870 && scrollY < 990) {
        setOpenSecond(true)
      }
      if (scrollY > 1000 && scrollY < 1150) {
        setOpenThird(true)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className={style.mainConatiner}>
      <div className={style.container} id="about">
        <div className={style.textContainer}>
          <div className={style.mainText}>
            Are&nbsp;you&nbsp;
            <AlternatingOne />
            seeking&nbsp;
            <br />
            <span className={style.mainText}>
              <AlternatingTwo />
            </span>{' '}
          </div>
          <div className={style.subText}>
            Discover How<span className={style.highlightedPeriod}>.</span>
          </div>
        </div>
        <div className={style.cardContainer}>
          <div
            className={`${style.singleCard}${
              openFirst ? ` ${style.openFirst}` : ''
            }`}
          >
            <p className={style.cardTitle}>Feed 2.0</p>
            <p className={style.cardTitleMobile}>Feed 2.0</p>
            <p className={style.cardText}>
              Your CV powers a personalized feed of jobs, courses, and events — no noise, no spam, just actionable, relevant opportunities.
            </p>
          </div>
          <div
            className={`${style.singleCard}${
              openSecond ? ` ${style.openSecond}` : ''
            }`}
          >
            <p className={style.cardTitle}>Chimp Quick chat</p>
            <p className={style.cardTitleMobile}>Chimp Quick chat</p>
            <p className={style.cardText}>
              Drop a job,  event or anything from your feed into chat and get instant insights: fit score, skill gaps, next steps, and smart recommendations.
            </p>
          </div>
          <div
            className={`${style.singleCard}${
              openThird ? ` ${style.openThird}` : ''
            }`}
          >
            <p className={style.cardTitle}>Custom Roadmaps</p>
            <p className={style.cardTitleMobile}>Custom Roadmaps</p>
            <p className={style.cardText}>
              Custom-built career paths tailored to your experience, goals, and learning style — complete one to unlock expert sessions and exclusive communities.
            </p>
          </div>
        </div>
        <button
          className={style.button}
          onClick={() => {
          // Navigate to the same page but request login popup
          navigate('/?auth=login')
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }}
        >
          Try it now
        </button>
      </div>
    </div>
  )
}

export default AboutChimp
